<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '~~/lib/tw-utils'

const props = defineProps<{
  class?: HTMLAttributes['class']
}>()
</script>

<template>
  <div :class="cn('flex flex-col gap-y-1.5 text-center sm_text-left', props.class)">
    <slot />
  </div>
</template>
